import { axiosFactory } from '../../../client';
import * as ROUTE from './routes';
import { userClient } from '../../payment-report/@opadmin/api-services/api';
import { KeyValueResponse } from '../../../../api-refactored/typings';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateAccountManagementClient = axiosFactory(baseURL, timeout);

export const postPurgeAccount = (csrfToken: string, examLevel: string) =>
  candidateAccountManagementClient.post<undefined>(csrfToken, ROUTE.POST_PURGE_ACCOUNTS(examLevel));

export const getOrganisations = () =>
  userClient.get<KeyValueResponse[]>(`${ROUTE.GET_ORGANIZATIONS}`);

export const getAccountStatusList = (isCandidate: boolean) =>
  userClient.get<KeyValueResponse[]>(`${ROUTE.GET_USER_ACCOUNT_STATUS}`, { isCandidate });
